/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { useCallback, useMemo, useRef } from "react";

export const useTimer = () => {
  const startTime = useRef<number>(-1);

  const start = useCallback(() => {
    startTime.current = Date.now();
  }, []);

  const end = useCallback(() => {
    if (startTime.current === -1) {
      throw Error("Timer has not started.");
    }
    const time = Date.now() - startTime.current;
    startTime.current = -1;
    return time;
  }, []);

  return useMemo(() => ({ start, end }), [end, start]);
};
